import React, {FunctionComponent} from "react";

const styles = require("./aboutCardText.component.scss");

export interface AboutCardTextProps {
    title: string;
    subTitle: string;
    asTitle?: boolean;
}

export const AboutCardText: FunctionComponent<AboutCardTextProps> = props => {
    const {title, subTitle, asTitle} = props;

    return (
        <div className={`${styles.aboutTextContainer} ${asTitle ? styles.asTitle : ''}`}>
            <h3 className={styles.aboutTextTitle}>{title}</h3>
            <div className={styles.aboutTextSubTitle}>{subTitle}</div>
        </div>
    );
};
